import { useContext } from 'react';
import { GameContext } from 'contexts/GameContext';
import { Paragraph } from 'elements/Text';

const Author = () => {
  const { author } = useContext(GameContext);

  return (
    <Paragraph>{author}</Paragraph>
  );
}

export default Author;
